<template>
  <div class="">
    <div class="profile" style="height: 60px;">
      <div class="work-status toDelete" v-if="workStatus === '0'">
        <a href="javascript:;" class="bt-todelete" title="删除">删除</a>
        <span class="left-time">剩余时间
          <span class="colon">:</span>
          <span class="left-days">2</span>天
        </span>
        <a href="javascript:;" class="bt-not-delete">取消删除</a>
      </div>

      <div class="work-status online" v-if="workStatus === 'is_publish'">
        <a href="javascript:;" class="bt-online" title="已上线">已上线</a>
        <span class="online-time">上线时间
          <span class="online-colon">:</span>
          <span class="online-days">{{publishTime}}</span>
        </span>
        <a href="javascript:;" class="bt-change-download" @click="showPop=true">下架该作品</a>
      </div>

      <div class="work-status deleted" v-else-if="workStatus === 'is_down'">
        <a href="javascript:;" class="bt-deleted">已下架</a>
        <span class="downloadTime">下架时间
          <span class="deleted-colon">:</span>
          <span class="deteled-time">{{downTime}}</span>
        </span>
        <a href="javascript:;" class="bt-up" @click="upWork">上架</a>

      </div>

    </div>
    <div class="profile mt15">
      <ul class="profile-division">
        <li>
          <i class="bk-icon icon-heart"></i>
          <div class="middle">{{totalCollection || '0'}}</div>
          <div class="small">收藏量</div>
        </li>
        <li>
          <i class="bk-icon icon-download"></i>
          <div class="middle">{{totalDownload || '0'}}</div>
          <div class="small">下载量</div>
        </li>
        <li>
          <i class="bk-icon icon-star"></i>
          <div class="middle">
            <span class="star" :class="starMap[evaluationStars]">
              <i></i>
              <i></i>
              <i></i>
              <i></i>
              <i></i>
            </span>
          </div>
          <div class="small">综合评星</div>
        </li>
        <li>
          <i class="bk-icon icon-money"></i>
          <div class="middle">{{totalIncome || '0'}}</div>
          <div class="small">总收入</div>
        </li>
        <li>
          <i class="bk-icon icon-eye"></i>
          <div class="middle">{{totalFlow || '0'}}</div>
          <div class="small">总浏览量</div>
        </li>
      </ul>
    </div>
    <div class="profile mt15">
      <div class="profile-visited visited">
        <div class="profile-visited-echarts" >
          <span style="font-size: 14px;color: #4f515e; font-weight:700;padding-left:10px;" v-show=" isNullLine&&!isLineLoading">作品访问量统计对比图</span>
          <div id="container-left" :style="{width:'514px',height:'254px'}" v-line="lineChartData" v-show="!isLineLoading && !isNullLine">
          </div>
          <loading :ifLoadingStart="isLineLoading" style="padding: 30px 0"></loading>

          <div v-show="isNullLine && !isLineLoading" class="attention-null" style="padding:0 244px;margin-bottom: 200px;">
            <tr class="attention-null">
              <img src="../../../images/personal_center/work-null.png" alt="">
              <p>暂无数据</p>
            </tr>
          </div>
          <loading :ifLoadingStart="isLineLoading" style="padding: 30px 0"></loading>
        </div>
      </div>
      <div class="profile-visited users">
        <div class="profile-visited-users">
          <div id="container-right" :style="{width:'342px',height:'254px'}" v-chart="pieChartData" v-if="!isPieLoading">

          </div>
          <loading :ifLoadingStart="isPieLoading" style="padding: 30px 0"></loading>
        </div>
      </div>
    </div>
    <div class="profile mt15" style="width:911px" v-if="!isTodayLoading">
      <div class="profile-news today">
        <h2>今日动态</h2>
        <div class="profile-news-box">
          <section class="collected-work">
            <ul class="work-list">
              <li>
                <dl class="work-list-item" v-for="(item,index) in todayRecord">
                  <dt>
                    <div id="workProfile">
                        <i class="icon-calendar"></i>
                        <!-- <span class="today-time">{{item.day}}</span> -->
                        <span class="today-time">{{item.items[index].day}}</span>
                    </div>
                    
                  </dt>
                  <dd class="clearfix" v-for="item in item.items">
                    <div class="left-box">
                      <i class="icon-ellipse"></i>
                      <span>{{item.time}}</span>
                      <img :src='item.logo' alt="" v-if="item.logo.indexOf('http') > -1" style="width:40px;height:40px">
                      <img src="../../../images/personal_center/avatar_default.png" alt="" v-else style="width:40px;height:40px">
                    </div>
                    <div class="right-box">
                      <div class="content" v-html="item.title"></div>
                      <p class="comment" v-for="addition in item.addition" v-html="addition"></p>
                    </div>
                  </dd>
                  <dd>
                    <i class="icon-dot-circle"></i>
                    <!-- <a href="javascript:" class="get-more more" @click="getMore(todayPage.curPage+1)">查看更多动态</a> -->
                    <a href="javascirpt:" :class="['get-more',{'noData':todayPage.curPage > todayPage.totalPage}]" @click="getMore(todayPage.curPage+1)" v-show="todayPage.curPage < todayPage.totalPage">查看更多动态</a>
                  </dd>
                </dl>
              </li>
            </ul>
          </section>
          <div v-show="isNullToday&&!isTodayLoading" class="attention-null" style="padding:0 244px;margin-bottom: 200px;">
            <tr class="attention-null">
              <img src="../../../images/personal_center/work-null.png" alt="">
              <p>今日尚未有动态</p>
            </tr>
          </div>
        </div>
      </div>
      <div class="profile-news visited">
        <h2>最近访问记录</h2>
        <div class="profile-visited-box">
          <template></template>
          <ul>
            <li v-for="item in accessList">
              <div class="avatar">
                <img :src='item.user_logo' alt="" v-if="item.user_logo.indexOf('http') > -1" style="width:50px;height:50px">
                <img src="../../../images/personal_center/avatar_default.png" alt="" v-else style="width:50px;height:50px">
              </div>
              <div class="records">
                <p class="name">
                  <span>{{item.nick_name}}</span>

                  <i class="icon black">F</i>
                </p>
                <p class="time">{{item.visit_at}}</p>
              </div>
            </li>
          </ul>
          <a v-if="Number(accessPage.curPage) < Number(accessPage.totalPage)"  href="javascirpt:" class="more" @click="viewMoreAccessList">查看更多记录
          </a>
          <div v-show="isNullAccess && !isTodayLoading" class="attention-null" style="padding:0 50px">
            <tr class="attention-null">
              <img src="../../../images/personal_center/work-null.png" alt="">
              <p>尚未有用户访问</p>
            </tr>
          </div>
        </div>
      </div>
    </div>
     <!-- 删除确定弹出框 -->
    <div class="pop-wrapper" v-if="showPop">
      <div class="pop-box">
        <div class="pop-header clearfix">
          <a href="javascript:;" class="fr" @click="showPop=false">
            <img src="../../../images/common/close.png" alt="">
          </a>
        </div>
        <div class="pop-body">
          确定下架该作品？
        </div>
        <div class="pop-footer">
          <a href="javascript:;" class="yes" @click="downWork">确定</a>
          <a href="javascript:;" class="no" @click="showPop=false">取消</a>
        </div>
      </div>
    </div>
    <!-- 弹出框子组件 -->
    <v-alert :options="options"></v-alert>
    <loading :ifLoadingStart="isTodayLoading" style="padding: 30px 0"></loading>
  </div>
</template>
<script type="text/javascript">
  import vue from 'vue'
  import echarts from 'echarts'
  import loading from '../../loading.vue' //导入加载子组件
  import vAlert from '../../alert.vue'    //导入弹出框子组件
  import popup from './../../popup.vue'

  Vue.directive('chart', function (el, binding) {
    let cirCharts = echarts.init(el);
    cirCharts.setOption({
      title: {
        text: binding.value.title,
        textStyle: {
          fontSize: 14,
          fontWeight: 700,
          color: '#4f515e'
        },
        left: '3%'
      },
      color: ['#3c96ff', '#222330', '#ffb400', '#30d878'],
      tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b}: {c} ({d}%)"
      },
      legend: {
        width: 180,
        height: 180,
        orient: 'vertical',
        left: 223,
        bottom: 50,
        itemWidth: 14,
        itemHeight: 14,
        itemGap: 23,
        data: binding.value.data
      },
      grid: {
        left: 33,
        bottom: 57,
        containLabel: true
      },
      series: binding.value.series
    })

  });

  Vue.directive('line', function (el, binding) {
    let lineCharts = echarts.init(el);

    lineCharts.setOption({
      title: {
        text: binding.value.title,
        textStyle: {
          fontSize: 14,
          fontWeight: 700,
          color: '#4f515e'
        },
        left: '3%'
      },
      backgroundColor: '#ffffff ',
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        }
      },
      legend: {
        data: ['服务商', '企业用户', '个体用户', '游客'],
        icon: 'rect',
        right: '4%', //图例组件与下方图表右对齐
        itemWidth: 12, //图标组件每项的大小
        itemHeight: 12,
        textstyle: {
          fontFamily: 'MicrosoftYaHei',
          fontSize: 12,
          fontWeight: 'normal',
          fontStretch: 'normal',
          lineHeight: 36,
          letterSpacing: 0,
          color: 888991
        },
        data: binding.value.data
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [{
        type: 'category',
        boundaryGap: false,
        data: binding.value.xAxis[0].data,
        axisLine: {
          lineStyle: {
            width: 1,
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: '#e6e6e7' // 0% 处的颜色
              }, {
                offset: 1,
                color: '#e6e6e7' // 100% 处的颜色
              }],
              globalCoord: false // 缺省为 false

            }
          }
        },
        axisTick: {
          inside: true,
          length: 5,
          lineStyle: {
            color: '#e6e6e7'
          }

        }

      }],
      yAxis: [{
        type: 'value',
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        splitLine: {
          lineStyle: {
            type: 'dashed'
          }
        },

      }],
      series: [{
          name: '今天',
          color: '#30d878',
          smooth: 0.3,
          symbol: 'none',
          type: 'line',
          stack: '总量',
          areaStyle: {
            normal: {}
          },
          data: binding.value.series[0].data,
        },
        {
          name: '昨天',
          smooth: 0.3,
          symbol: 'none',
          color: '#3c96ff',
          type: 'line',
          stack: '总量',
          areaStyle: {
            normal: {}
          },
          data: binding.value.series[1].data,
        },
        {
          name: '上周',
          color: '#ffb400',
          smooth: 0.3,
          symbol: 'none',
          type: 'line',
          stack: '总量',
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          areaStyle: {
            normal: {}
          },
          data: binding.value.series[2].data
        }
      ]
    })
  })

  export default {

    data() {
      return {
        showPop: false, //下架作品确认框
        workStatus: '', //作品状态
        defaultImage: '',
        todayRecord: [{
          day: '',
          items: []
        }],
        todayList: [],
        todayTime: '', //今日动态时间
        isNullToday: false, //今日动态为空
        isNullAccess: false, //最近访问为空
        isNullLine: false, //折线图数据为空
        publishTime: '',
        downTime: '',
        accessList: [], //最近访问记录
        pieChartData: { //饼图
          title: '',
          data: [],
          series: []
        },
        lineChartData: { //折线图
          title: '',
          xAxis: [],
          series: []
        },
        totalFlow: '', //总流量
        totalIncome: '', //总收入
        evaluationStars: '', //综合评价
        totalDownload: '', //总下载量
        totalCollection: '', //收藏量
        isLineLoading: true, //线形图加载
        isPieLoading: true, //饼图加载
        isTodayLoading: true, //今日动态
        isSummaryLoading: true, //顶部统计加载
        options: {
          msgText: '',
          msgIsSuccess: false
        },
        accessPage: { //查看更多记录
          curPage: 1,
          total: 1,
          totalPage: 1
        },
        todayPage: {
          curPage: 1,
          total: 1,
          totalPage: 1
        },

      }
    },
    methods: {
      /*
       ** 查看更多记录
       */
      viewMoreAccessList () {
        if (Number(this.accessPage.curPage) < Number(this.accessPage.totalPage)) {
          const workId = this.$route.params.wid;
          let page = this.accessPage.curPage + 1;
          axios.get(myUrl + `sns/visit_user/product/${workId}/?page=${page}`).then((res) => {
            let resData = res.data.data;
            if (res.data.result) {
              resData.items.forEach(item => {
                this.accessList.push(item);
              })
              this.accessPage = resData.page
            } else {
              this.options = {
                msgText: res.data.message,
                msgIsSuccess: true
              }
            }
          })
        }
      },
      /*
       ** 初始化线图
       */
      initLine() {
        const app_id = this.$route.params.wid;
        axios.post(myUrl + `/sns/visit_stat/product/${app_id}/`).then((res) => {
          let resData = res.data;
          let xAxisData = [];
          let yAxisData = [];
          let xAxisTime = [];
          let todayValue = [];
          let yesValue = [];
          let weekValue = [];
          if (resData.result) {
            this.isLineLoading = false;
            let lineData = resData.data;
            for (var i =0; i < 24; i++) {
              xAxisTime.push(i + ':00')
            }
            for (var i = 0; i < lineData.week.length; i++) {
              // xAxisTime.push(lineData.week[i]['0']);
              weekValue.push(lineData.week[i]['1'])
            }
            for (var i = 0; i < lineData.today.length; i++) {
              // xAxisTime.push(lineData.today[i]['0']);
              todayValue.push(lineData.today[i]['1'])
            }
            for (var i = 0; i < lineData.yes.length; i++) {
              // xAxisTime.push(lineData.yes[i]['0']);
              yesValue.push(lineData.yes[i]['1'])
            }
            if (!todayValue.length && !yesValue.length && !weekValue.length) {
              this.isNullLine = true
            }
            this.lineChartData = {
              title: '作品访问量统计对比图',
              xAxis: [{
                type: 'category',
                boundaryGap: false,
                data: xAxisTime,
                axisLine: {
                  lineStyle: {
                    width: 1,
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [{
                        offset: 0,
                        color: '#e6e6e7' // 0% 处的颜色
                      }, {
                        offset: 1,
                        color: '#e6e6e7' // 100% 处的颜色
                      }],
                      globalCoord: false // 缺省为 false

                    }
                  }
                },
                axisTick: {
                  inside: true,
                  length: 5,
                  lineStyle: {
                    color: '#e6e6e7'
                  }

                }

              }],
              series: [{
                  name: '今天',
                  color: '#30d878',
                  smooth: 0.3,
                  symbol: 'none',
                  type: 'line',
                  stack: '总量',
                  areaStyle: {
                    normal: {}
                  },
                  data: todayValue
                },
                {
                  name: '昨天',
                  smooth: 0.3,
                  symbol: 'none',
                  color: '#3c96ff',
                  type: 'line',
                  stack: '总量',
                  areaStyle: {
                    normal: {}
                  },
                  data: yesValue
                },
                {
                  name: '上周',
                  color: '#ffb400',
                  smooth: 0.3,
                  symbol: 'none',
                  type: 'line',
                  stack: '总量',
                  label: {
                    normal: {
                      show: true,
                      position: 'top'
                    }
                  },
                  areaStyle: {
                    normal: {}
                  },
                  data: weekValue
                }
              ]
            }
          } else {
            // 错误提示
            this.options = {
              msgIsSuccess: false,
              msgText: resData.message
            }
          }
        })
      },
      /*
       ** 初始化饼图
       */
      initPieData() {
        const app_id = this.$route.params.wid;
        axios.post(myUrl + `sns/visit_count/product/${app_id}/`).then((response) => {

          let res = response.data;
          this.totalFlow = res.data.all;
          let result = []
          if (res.result) {
            this.isPieLoading = false;
            let pieData = res.data;
            result.push({
              name: '服务商',
              value: pieData['2']
            })
            result.push({
              name: '企业用户',
              value: pieData['1']
            })
            result.push({
              name: '个体用户',
              value: pieData['0']
            })
            result.push({
              name: '游客',
              value: pieData['3']
            })
            this.pieChartData = {
              title: '用户群体类型',
              data: [{
                  name: '服务商',
                  icon: 'circle',
                  textstyle: {
                    fontFamily: 'MicrosoftYaHei',
                    fontSize: 20,
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    lineHeight: 36,
                    letterSpacing: 0,
                    borderColor: 'red'
                  }
                },
                {
                  name: '企业用户',
                  icon: 'circle',
                  textstyle: {
                    fontFamily: 'MicrosoftYaHei',
                    fontSize: 12,
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    lineHeight: 36,
                    letterSpacing: 0,
                    color: '#888991'
                  }
                },
                {
                  name: '个体用户',
                  icon: 'circle',
                  textstyle: {
                    fontFamily: 'MicrosoftYaHei',
                    fontSize: 12,
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    lineHeight: 36,
                    letterSpacing: 0,
                    color: '#888991'
                  }
                },
                {
                  name: '游客',
                  icon: 'circle',
                  textstyle: {
                    fontFamily: 'MicrosoftYaHei',
                    fontSize: 20,
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    lineHeight: 36,
                    letterSpacing: 0,
                    color: '#888991'
                  }
                },
              ],
              series: [{
                name: '访问来源',
                type: 'pie',
                itemStyle: {
                  normal: {
                    label: {
                      show: false
                    },
                    labelLine: {
                      show: false
                    }
                  }
                },
                radius: ['50%', '70%'],
                center: [113, 137],
                avoidLabelOverlap: false,
                label: {
                  normal: {
                    show: false,
                    position: 'outside'
                  },
                },
                labelLine: {
                  normal: {
                    show: false
                  }
                },
                data: result,
                itemStyle: {
                  borderColor: 'white',
                  borderWidth: 2
                }
              }]
            }
          } else {
            // 错误提示
            this.options = {
              msgIsSuccess: false,
              msgText: res.message
            }
          }
        }, reject => {
          this.options = {
            msgText: reject.message,
            msgIsSuccess: false
          }
        })
      },
      /*
       ** 顶部的统计数据
       */
      getStatisticsData() {
        const app_id = this.$route.params.wid;
        axios.get(myUrl + `core/product/stat/${app_id}/`).then((res) => {
          if (res.data.result) {
            let resData = res.data.data;
            let appStat = resData.app_stat;
            this.isSummaryLoading = false;
            this.totalIncome = appStat.income;
            this.evaluationStars = appStat.star;
            this.totalDownload = appStat.download_num;
            this.totalCollection = appStat.fan_num;
            this.workStatus = resData.online_status
            this.publishTime = resData.basic.publish_time
            this.downTime = resData.basic.down_time
          } else {
            this.options = {
              msgText: resData.message,
              msgIsSuccess: false
            }
          }
        })
      },
      /*
       ** 最近访问
       */
      getaccessData() {

        const app_id = this.$route.params.wid;
        axios.get(myUrl + `sns/visit_user/product/${app_id}/`).then((res) => {
          let resData = res.data;
          if (resData.result) {
            this.isTodayLoading = false;
            if (resData.data.items.length) {
              this.accessPage = resData.data.page;
              this.accessList = resData.data.items;
            } else {
              this.isNullAccess = true;
            }
          } else {
            this.options = {
              msgText: resData.message,
              msgIsSuccess: false
            }
          }
        })
      },
      /*
       ** 今日动态
       */
      getTodayData(more) {
        let tempList = [];
        const workId = this.$route.params.wid;
        if (this.todayPage.curPage < 1 || this.todayPage.curPage > this.todayPage.totalPage) {
          return;
        } else {
          axios.get(myUrl + `feed/latest/product/${workId}/`).then((res) => {
            if (res.data.result) {
              this.isTodayLoading = false;
              let resData = res.data.data;
              this.todayRecord = resData.days;
              if (this.todayRecord.length) {
                this.isNullToday = false;
                if (more) {
                  this.todayRecord.forEach(element => {
                    element.items = element.items.splice(0, this.todayPage.curPage * 10);
                    // element.items = element.items.splice(0, 2);
                  });
                } else {
                  this.todayRecord.forEach(element => {
                    element.items = element.items.splice(0, 10);
                  });
                  this.todayPage = resData.page;
                }

              } else {
                this.isNullToday = true;
              }
            } else {
              this.options = {
                msgText: res.data.message,
                msgIsSuccess: false
              }
            }
          })
        }
      },
      /*
       ** 今日动态查看更多
       */
      getMore (page) {

        this.todayPage.curPage = page;
        this.getTodayData(true);
      },
      /*
       ** 确定下架作品
       */
      downWork () {
        this.showPop = false;
        const workId = this.$route.params.wid;
        axios.get(myUrl + `core/product/shelf/${workId}/down/`).then((res) => {
          if (res.data.result) {
            this.options = {
              msgText: '下架成功！',
              msgIsSuccess: true
            }
            this.getStatisticsData();
            this.workStatus = 'is_down';
          } else {
            this.options = {
              msgText: res.data.message,
              msgIsSuccess: false
            }
          }
        })
      },
      /*
       ** 上架作品
       */
      upWork () {
        const workId = this.$route.params.wid;

        axios.get(myUrl + `core/product/shelf/${workId}/up/`).then((res) => {
          if (res.data.result) {
            this.options = {
              msgText: '上架成功！',
              msgIsSuccess: true
            }
            this.getStatisticsData();
            this.workStatus = 'is_publish'
          } else {
            this.options = {
              msgText: res.data.message,
              msgIsSuccess: false
            }
          }
        })
      }
    },
    components: {
      loading,
      vAlert
    },
    //调用
    mounted() {
      this.getTodayData();
      this.initLine();
      this.initPieData();
      this.getStatisticsData();
      this.getaccessData();
    },
    created() {
       this.starMap = ["","star1","star2","star3","star4","star5"];
    }
  }
</script>

<style media="screen" lang="scss" scoped>
  .profile {
    display: flex;
    position: relative;
    &:first-child {
      .work-status {
        &:first-child {
          .bt-todelete {
            position: absolute;
            line-height: 23px;
            text-align: center;
            left: 20px;
            top: 18px;
            display: inline-block;
            width: 55px;
            height: 25px;
            background-color: #ff5656;
            box-sizing: border-box;
            border: 1px solied #ff5656;
            border-radius: 4px;
            font-size: 12px;
            color: #ffffff;
          }
          .left-time {
            position: absolute;
            left: 86px;
            top: 24px;
            font-size: 12px;
            color: #ff5656;
          }
          .bt-not-delete {
            position: absolute;
            right: 20px;
            top: 11px;
            width: 100px;
            height: 38px;
            box-sizing: border-box;
            border: 1px solid #e6e6e7;
            font-size: 12px;
            color: #4f515e;
            line-height: 38px;
            text-align: center;
          }
        }
        &.deleted {
          position: relative;
          width: 100%;
          .bt-deleted {
            position: absolute;
            line-height: 22px;
            text-align: center;
            display: inline-block;
            left: 20px;
            top: 18px;
            width: 55px;
            height: 24px;
            background-color: #fafafa;
            box-sizing: border-box;
            border: 1px solied #f4f4f4;
            border-radius: 4px;
            font-size: 12px;
            color: #4f515e;
          }
          .downloadTime {
            position: absolute;
            left: 86px;
            top: 22px;
            font-size: 12px;
            color: #a6a6a6;
          }
          .bt-up {
            position: absolute;
            box-sizing: border-box;
            right: 20px;
            top: 11px;
            width: 100px;
            height: 38px;
            box-sizing: border-box;
            border-radius: 2px;
            color: #ffffff;
            line-height: 38px;
            text-align: center;
            background-color: #57a3f1;
          }
          .bt-end-delete {
            position: absolute;
            right: 20px;
            top: 11px;
            width: 100px;
            height: 38px;
            box-sizing: border-box;
            border-radius: 2px;
            color: #ffffff;
            line-height: 38px;
            text-align: center;
            background-color: #ff5656;
          }
        }
        &.online {
          .bt-online {
            position: absolute;
            line-height: 25px;
            text-align: center;
            left: 20px;
            top: 18px;
            display: inline-block;
            width: 55px;
            height: 25px;
            background-color: #5bd18b;
            box-sizing: border-box;
            border-radius: 4px;
            font-size: 12px;
            color: #ffffff;
          }
          .online-time {
            position: absolute;
            left: 86px;
            top: 23px;
            font-size: 12px;
            color: #c0c0c0;
          }
          .bt-change-download {
            position: absolute;
            right: 20px;
            top: 11px;
            width: 100px;
            height: 38px;
            box-sizing: border-box;
            border-radius: 2px;
            color: #ffffff;
            line-height: 38px;
            text-align: center;
            background-color: #57a3f1;
          }
        }
      }
    }
    &.mt15 {
      border-top: solid 15px #f4f4f4;
      margin-top: 0px !important;
    }

    h2 {
      font-size: 14px;
      color: #4f515e;
      font-weight: bold;
      padding-left: 10px;
    }
    .profile-division {
      margin-right: -2px;
      margin-left: -2px;
      display: table;
      li {
        width: 183px;
        float: left;
        height: 152px;
        padding-top: 40px;
        border-right: solid 2px #f4f4f4;
        position: relative;
        text-align: center;
        .middle {
          font-size: 30px;
          line-height: 58px;
          color: #4f515e;
        }
        .small {
          font-size: 14px;
          color: #888991;
        }
      }
    }
    &-visited {
      padding: 16px 10px;
      float: left;
      box-sizing: border-box;
      position: relative;
      .loading {
        position: absolute;
        left: 1px;
        top: 1px;
        height: 100%;
        line-height: 226px;
      }
      &.visited {
        width: calc(100% - 377px);
        .profile-visited-echarts {
          position: relative;
          .attention-null {
            position: absolute;
            left: 5px;
            top: -95px;
            height: 100%;
            width: 100%;
            /* .worksPic {
              font-size: 12px !important;
              color: #4f515e !important;
              font-weight: 700 !important;
            } */

          }
        }
      }
      &.users {
        width: 377px;
        float: right;
        border-left: solid 15px #f4f4f4;
        .profile-visited-users {
          width: 100%;
          height: 254px;
        }
      }
      h2 {
        line-height: 24px;
      }
      &-echarts {
        width: 514px;
        height: 254px;
      }
    }
    &-news {
      h2 {
        font-size: 14px;
        font-weight: bold;
        padding: 0 20px;
        line-height: 42px;
        height: 42px;
        overflow: hidden;
        color: #4f515e;
        border-bottom: solid 1px #f4f4f4;
      }
      &.today {
        width: 630px;
        border-right: solid 15px #f4f4f4;
        float: left;
        padding-bottom: 45px;
        .profile-news-box {
          width: 100%;
          min-height: 254px;
        }
      }
      &.visited {
        width: 267px;
        float: right;

        .profile-visited-box {
          width: 267px;
          min-height: 254px;
          padding: 19px 23px;
          a {
            color: #57a3f1;
            font-size: 14px;
            display: table;
            margin: 0 auto;
            &.nullData {
              color: #cccccc;
            }
            &.noData {
              color: #cccccc;
            }
          }
          ul {
            li {
              width: 100%;
              height: 54px;
              overflow: hidden;
              margin-bottom: 10px;
              display: table;
              .avatar {
                width: 54px;
                height: 54px;
                border-radius: 2px;
                overflow: hidden;
                display: table-cell;
                vertical-align: middle;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .records {
                width: calc(100% - 54px - 46px);
                padding-left: 15px;
                display: table-cell;
                vertical-align: middle;
                .name {
                  line-height: 22px;
                  font-size: 14px;
                  color: #4f515e;
                  span {
                    display: inline-block;
                    max-width: 126px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    float: left;
                  }
                  .icon {
                    width: 16px;
                    height: 16px;
                    border-radius: 2px;
                    text-align: center;
                    line-height: 16px;
                    font-size: 12px;
                    display: inline-block;
                    color: #ffffff;
                    margin-left: 10px;
                    &.black {
                      background: #000000;
                    }
                    &.yellow {
                      background: #ffb400;
                    }
                    &.green {
                      background: #30d878;
                    }
                    &.blue {
                      background: #3c96ff;
                    }
                  }
                }
                .time {
                  line-height: 18px;
                  font-size: 12px;
                  color: #a6a6a6;
                }
              }
            }
          }
        }
      }
    }
  }

  .bk-icon {
    position: absolute;
    left: 13px;
    top: 13px;
    font-size: 16px;
  }

  .icon-money {
    width: 16px;
    height: 16px;
    background: url(../../../images/application_detail/icon-money.png) no-repeat;
  }

  .work-list {
    margin-top: 35px;
    margin-left: 20px;
    >li {
      >dl {
        position: relative;
        >dd{
          .icon-dot-circle {
            position: absolute;
            left: -15px;
            top: 26px;
            display: inline-block;
            width: 30px;
            height: 30px;
            background: url(../../../images/personal_center/icon-dot-circle.png) no-repeat;
          }
          .get-more {
            position: absolute;
            left: 30px;
            top: 30px;
            color: #57a3f1;
            font-size: 14px;
            margin: 0 auto;
          }
          .noData {
            color: #cccccc;
          }
        }

      }
    }
    li:first-child {
      dt {

        .icon-calendar {
          background: url(../../../images/personal_center/icon-calendar-box.png);
        }
        .today-time {
          font-size: 14px;
          color: #888991 !important;
          font-family: 'pingFang-SC-Regular', '\5FAE\8F6F\96C5\9ED1', Arial !important;
        }
      }
    }
    li:nth-child(2) {
      dt {
        .icon-calendar {
          background: url(../../../images/personal_center/icon-calendar-box2.png);
        }
      }
    }
    .work-list-item {
      color: #444;
      dt {
        height: 32px;
        #workProfile {
          .icon-calendar {
            position: relative;
            display: inline-block;
            width: 35px;
            height: 32px;
            margin-right: 12px;
            background: url(../../../images/personal_center/icon-calendar-box3.png);
            &:before {
              content: '';

            }
          }
          span {
            vertical-align: top;
            line-height: 32px;
          }
        }
        
      }
      dd:nth-child(3) {
        height: 50px;
      }
      dd {
        padding-top: 20px;
        margin-left: 16px;
        border-left: 4px solid #e5e5e5;
        position: relative;

        .left-box {
          float: left;
          margin-left: 15px;
          height: 42px;
          .icon-ellipse {
            display: inline-block;
            width: 16px;
            height: 16px;
            background: url(../../../images/personal_center/icon-ellipse.png);
            position: absolute;
            left: -10px;
            top: 31px;
          }
          .avatar {
            width: 42px;
            height: 42px;
            border-radius: 2px;
            margin-left: 15px;
          }
        }
        .right-box {
          float: left;
          margin-left: 15px;
          min-width: 400px;
          .text-blue {
            color: #57a3f1;
          }
          .content {
            line-height: 42px;
          }
          .comment {
            color: #888888;
            font-size: 12px;
            word-wrap: break-word;
            text-indent: 2rem;
          }
          .icon-comment {
            position: absolute;
            margin-top: 3px;
            vertical-align: bottom;
            display: inline-block;
            width: 14px;
            height: 14px;
            background: url(../../../images/personal_center/icon-comment.png);
            margin-right: 10px;
          }
        }
      }

    }
  }
  .pop-wrapper {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .3);
    z-index: 1111;
    .pop-box {
      width: 400px;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      padding: 20px;
      border-radius: 3px;
      .pop-header {
        margin-bottom: 10px;
      }
      .pop-body {
        text-align: center;
        font-size: 22px;
        color: #333;
        width: 100%;
      }
      .pop-footer {
        padding: 20px 45px 20px;
        text-align: center;
        font-size: 0;
        .yes,
        .no {
          font-size: 16px;
          height: 36px;
          line-height: 36px;
          border-radius: 3px;
          display: inline-block;
          width: 110px;
        }
        .yes {
          color: #fff;
          background: #57a3f1;
          margin-right: 20px;
        }
        .no {
          color: #666;
          border: 1px solid #e5e5e5;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// work_profile.vue?76d63b95